import messages from "messages";
// styles
import styles from "./styles.module.scss";
// components
import { ReactComponent as OutlineGrid2Horizontal } from "assets/svg/outline-grid-2-horizontal.svg";
import { ReactComponent as OutlineGrid4 } from "assets/svg/outline-grid-4.svg";

import IconButton from "components/icon-button";
import UploadMenu from "../upload-menu";
// utils
import getClasses from "utils/getClasses";
// types
import type { ChangeEventHandler, Dispatch, SetStateAction } from "react";
import type { CreateDirectoryFunc } from "contexts/orchid-drive/components/orchidDriveProvider";
import { AmplitudePageName, track } from "utils/amplitude";

type Props = {
  storageDrive: StorageDrive;
  isGrid: boolean;
  setIsGrid: Dispatch<SetStateAction<boolean>>;
  currDirId: string | null;
  patientUserId?: string;
  createDirectory: CreateDirectoryFunc;
  onUpload: ChangeEventHandler<HTMLInputElement>;
  analyticsPageName: AmplitudePageName;
};
const ActionsBar = ({
  storageDrive,
  isGrid,
  setIsGrid,
  currDirId,
  patientUserId,
  createDirectory,
  onUpload,
  analyticsPageName,
}: Props) => {
  return (
    <div
      className={styles["actions-bar"]}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className={styles["actions-bar__left"]}>
        {messages.uploads}
        <div className={styles["actions-bar__icon-plus"]}>
          <UploadMenu
            createDirectory={createDirectory}
            onUpload={onUpload}
            patientUserId={patientUserId}
            currDirId={currDirId}
            storageDrive={storageDrive}
            analyticsPageName={analyticsPageName}
          />
        </div>
      </div>
      <div className={styles["actions-bar__right"]}>
        <IconButton
          className={getClasses(
            styles["actions-bar__action-right"],
            isGrid && styles["actions-bar__action-right--selected"],
          )}
          onClick={() => {
            track(analyticsPageName, "grid-view-button", "click");
            setIsGrid(true);
          }}
        >
          <OutlineGrid4 />
        </IconButton>
        <IconButton
          className={getClasses(
            styles["actions-bar__action-right"],
            !isGrid && styles["actions-bar__action-right--selected"],
          )}
          onClick={() => {
            track(analyticsPageName, "row-view-button", "click");
            setIsGrid(false);
          }}
        >
          <OutlineGrid2Horizontal />
        </IconButton>
      </div>
    </div>
  );
};

export default ActionsBar;
